import CommentEditor from './CommentEditor'

export default CommentEditor
